module.exports = __webpack_public_path__ + "img/card_img_three.96c30c24.png";